namespace GeniuzPOS.Purchase {
    export interface ListAppPurRequestForm {
        WaitLv: Serenity.IntegerEditor;
        WaitApprove: Serenity.LookupEditor;
        SysDocNo: Serenity.StringEditor;
        PrTypeFg: Serenity.EnumEditor;
        SupplierId: Serenity.StringEditor;
        NetTotalInVat: Serenity.DecimalEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        LastApprove: Serenity.StringEditor;
        ApproveDate: Serenity.DateEditor;
        ShipId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
    }

    export class ListAppPurRequestForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ListAppPurRequest';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ListAppPurRequestForm.init)  {
                ListAppPurRequestForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.DateEditor;

                Q.initFormType(ListAppPurRequestForm, [
                    'WaitLv', w0,
                    'WaitApprove', w1,
                    'SysDocNo', w2,
                    'PrTypeFg', w3,
                    'SupplierId', w2,
                    'NetTotalInVat', w4,
                    'DocNo', w2,
                    'DocDate', w5,
                    'RefDocNo1', w2,
                    'RefDocNo2', w2,
                    'LastApprove', w2,
                    'ApproveDate', w5,
                    'ShipId', w2,
                    'Remark', w2
                ]);
            }
        }
    }
}
